/**
 * Created by mnaughton on 10/15/2015.
 */

import BaseListView from "core/views/Field/BaseListView";
import _ from "underscore";
export default BaseListView.extend({
  template: _.template(
    '<select class="form-control" name="<%-name%>"></select>'
  ),
  itemTemplate: _.template(
    "<option value=\"<%-value%>\" <%=selected ? 'selected=\"selected\"' : ''%>><%-text%></option>"
  ),

  events: {
    "change .form-control": "onChange",
    "keyup .form-control": "onChange",
  },

  getControlValue: function () {
    return this.$(".form-control").val();
  },

  setControlValue: function (value) {
    this.$(".form-control").val(value);
  },

  serialize: function () {
    return {
      name: this.field.id,
    };
  },

  serializeItems: function (items) {
    var useDefaultItem = this.options.defaultItem;

    items = items || [];

    if (useDefaultItem !== false && items.length && items[0].value) {
      //if the defaultItem option is not explicitly set to `false` and there is a non-empty value for the initial item, meaning it is not already a default value, then lets add one automatically
      useDefaultItem = useDefaultItem || true;
    }

    if (useDefaultItem) {
      var text = "Select " + this.options.field.get("label");

      if (_.isString(useDefaultItem)) {
        text = useDefaultItem;
      }

      items.unshift({
        text: text,
        value: "",
      });
    }

    return _.map(
      items,
      function (item) {
        return _.extend({}, item, {
          selected: item.value == this.getValue(),
        });
      },
      this
    );
  },

  insertItem: function (item) {
    this.$(".form-control").append(item);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/SelectView.js
// module id = 844
// module chunks = 1